module.exports = __webpack_public_path__ + "Server-Unknown.Ftp.68fa9f63c8d7fffb7c4fdc9c0d699738.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/machines/Server-Unknown.Ftp.png
// module id = 1268
// module chunks = 1